import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { AclService, EAccessName, EAccessType } from "./services/acl.service";
import { MasterApiService } from "../services/master-api.service";
import { ConfigService } from "../services/config.service";
import { AccessRouterService } from "./components/access-router-outlet/access-router.service";
import { filter, firstValueFrom } from "rxjs";

export const saveAppUri: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const uri = state.url
  const acl = inject(AclService);
  const api = inject(MasterApiService);
  if (api.auth.userValue && api.auth.userValue.lastUrl !== uri) {
    if (acl.isAllowed(_route.data['access'])) {
      api.patchUserLastUri(api.auth.userValue!.userName, uri).subscribe();
    }
  }
  return true;
};

export const access: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const configService = inject(ConfigService);
  const router = inject(Router);
  const acl = inject(AclService);
  await firstValueFrom(acl.acl$.pipe(filter(acl => acl !== null)));
  // Check if config service accepts the node
  const uri = state.url.split('?')[0];
  if (!configService.isNodeVisible(uri)) {
    const parts = uri.split('/');
    let dest = '/';
    if(parts[1] === 'admin') {
      if (parts.length < 2) {
        dest = uri + '/**';
      } else {
        dest = `${parts[1]}/**`;
      }
    }
    else{
      configService.getDefaultModuleUrl(parts[1]);
      if (parts.length < 4) {
        dest = uri + '/**';
      } else {
        dest = `${parts[1]}/${parts[2]}/**`;
      }
    }
    router.navigate([dest]);
  }
  // Check if the route is allowed
  if ('access' in route.data && route.data['access'] !== undefined) {
    // Get list of access permissions separated by comma
    const accessPermissions = route.data['access'].split(',') as EAccessName[];
    
    if (!accessPermissions.some(p => acl.isAllowed(p) || acl.isAllowed(p, EAccessType.Activable))) {
      const accessRouter = inject(AccessRouterService);
      accessRouter.setForbidden();
    }
  }

  return true;
};
